"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Icon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _oxygenConfig = require("@8x8/oxygen-config");

var _oxygenTooltip = _interopRequireWildcard(require("@8x8/oxygen-tooltip"));

var _InfoIcon = _interopRequireDefault(require("../styled/InfoIcon"));

var _IconWrapper = _interopRequireDefault(require("../styled/IconWrapper"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Icon = function Icon(_ref) {
  var theme = _ref.theme,
      testId = _ref.testId,
      infoBoxText = _ref.infoBoxText,
      infoBoxShowOn = _ref.infoBoxShowOn;
  return /*#__PURE__*/_react["default"].createElement(_IconWrapper["default"], null, /*#__PURE__*/_react["default"].createElement(_oxygenTooltip["default"], {
    theme: theme.tooltip,
    title: infoBoxText,
    orientation: _oxygenTooltip.directions.top,
    showOn: infoBoxShowOn
  }, /*#__PURE__*/_react["default"].createElement(_InfoIcon["default"], _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_ICON")), {
    color: theme.iconColor,
    size: theme.iconSize
  }))));
};

exports.Icon = Icon;
var _default = Icon;
exports["default"] = _default;
Icon.propTypes = {
  theme: _propTypes["default"].object.isRequired,
  testId: _propTypes["default"].string,
  infoBoxText: _propTypes["default"].node.isRequired,
  infoBoxShowOn: _propTypes["default"].oneOf([_oxygenTooltip.showOnTypes.click, _oxygenTooltip.showOnTypes.hover]).isRequired
};
Icon.defaultProps = {
  testId: 'LABEL'
};